import axios from 'axios';
import Config from '@/config';

const baseUrl = `${Config.firebaseFunctionsBaseUrl}`;

export default {
  addItineraryMessage: async function(messageBody) {
    const url = `${baseUrl}/addItineraryMessage`;

    const headers = {
      'Content-Type': 'application/json'
    };

    const result = await axios.post(url, messageBody, { headers });
    return result.data.record;
  }
};
